/* nm-pages-motion.js · catálogo / PDP: Lenis + ScrollTrigger. Pin real en desktop; no aborta por reduced-motion (solo suaviza). */
(function () {
  'use strict';
  function boot() {
    if (!window.gsap || !window.ScrollTrigger) return;
    var root = document.documentElement;
    var reduce = root.classList.contains('rm');
    var $ = function (s, r) { return (r || document).querySelector(s); };
    var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
    var isMobile = function () { return innerWidth <= 820; };
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });

    var lenis = null;
    if (!isMobile() && !reduce && matchMedia('(pointer:fine)').matches && window.Lenis) {
      lenis = new Lenis({
        duration: 1.35,
        smoothWheel: true,
        wheelMultiplier: 0.85,
        touchMultiplier: 1.2,
        easing: function (t) { return 1 - Math.pow(1 - t, 4); }
      });
      window.lenis = lenis;
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
    }

    function splitWords(el) {
      if (!el || el.dataset.split) return;
      el.dataset.split = '1';
      el.setAttribute('aria-label', (el.textContent || '').replace(/\s+/g, ' ').trim());
      var walk = function (n) {
        [].slice.call(n.childNodes).forEach(function (c) {
          if (c.nodeType === 3) {
            var f = document.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach(function (t) {
              if (!t) return;
              if (/^\s+$/.test(t)) { f.appendChild(document.createTextNode(t)); return; }
              var w = document.createElement('span'); w.className = 'w'; w.setAttribute('aria-hidden', 'true');
              var i = document.createElement('span'); i.className = 'wi'; i.textContent = t; w.appendChild(i); f.appendChild(w);
            });
            c.replaceWith(f);
          } else if (c.nodeType === 1) walk(c);
        });
      };
      walk(el);
    }

    /* orbes */
    $$('.cine-orb').forEach(function (orb, i) {
      gsap.to(orb, {
        y: i % 2 ? 100 : -140,
        x: i % 2 ? -60 : 80,
        ease: 'none',
        scrollTrigger: {
          trigger: orb.closest('[data-cine]') || document.body,
          start: 'top top', end: 'bottom bottom', scrub: 1.4
        }
      });
    });

    /* -------- COLLECTION / SEARCH: grid editorial (sin pin horizontal) -------- */
    var coll = $('[data-cine="collection"],[data-cine="search"]');
    if (coll) {
      if (!reduce) {
        gsap.from('.ch-count, .ch-sort, .ch-search, .ch-tabs, .ed-kicker, .ed-title, .ed-sub, .ed-sort, .cine-kicker, .cine-title, .cine-sub, .cine-sort, .cine-search', {
          opacity: 0, y: 22, duration: 0.9, ease: 'power3.out', stagger: 0.06, delay: 0.08
        });
      }
      var cards = $$('.ed-grid .card, .cine-track .card, .coll-grid .card', coll);
      if (cards.length && !reduce) {
        gsap.set(cards, { clearProps: 'opacity,visibility' });
        cards.forEach(function (card, i) {
          gsap.from(card, {
            y: 28, opacity: 0, duration: 0.7, ease: 'expo.out',
            scrollTrigger: { trigger: card, start: 'top 92%', once: true },
            delay: Math.min(i * 0.03, 0.3)
          });
        });
      }
    }

    /* -------- PDP PIN REAL (desktop) -------- */
    var pdp = $('[data-cine="product"]');
    if (pdp) {
      $$('.pdp-title.split', pdp).forEach(splitWords);
      var tw = $$('.pdp-title .wi', pdp);
      if (tw.length && !reduce) {
        gsap.set(tw, { yPercent: 110 });
        gsap.to(tw, { yPercent: 0, duration: 1.05, ease: 'expo.out', stagger: 0.035, delay: 0.1 });
      }
      /* Entrada corta solo móvil; en desktop el pin define el estado hero */
      if (!reduce && isMobile()) {
        gsap.from('.cine-pdp-copy .fade, .cine-pdp-copy .pdp-form, .cine-pdp-copy .lg', {
          opacity: 0, y: 24, duration: 0.85, ease: 'power3.out', stagger: 0.06, delay: 0.3
        });
        gsap.from('.cine-pdp-media .pdp-main', {
          y: 36, scale: 0.94, duration: 1.1, ease: 'expo.out', delay: 0.12
        });
      }

      var scene = $('#cine-pdp-scene');
      if (scene && !isMobile()) {
        if (!$('.cine-pin-progress', scene)) {
          var bar = document.createElement('div');
          bar.className = 'cine-pin-progress'; bar.setAttribute('aria-hidden', 'true');
          bar.innerHTML = '<i></i>';
          scene.appendChild(bar);
        }
        /* Estado inicial: frasco apenas más cerca (sin recortarlo) y bloque de compra nítido desde la carga */
        gsap.set('.cine-pdp-media', { xPercent: 3, scale: 1.03, transformOrigin: '50% 45%' });
        gsap.set('.cine-pdp-media .pdp-main', { scale: 1.01, y: 6 });
        gsap.set('.cine-pdp-copy', { xPercent: 3, y: 10, opacity: 1, filter: 'none' });
        gsap.set('.cine-orb--p', { scale: 0.7, opacity: 0.55 });

        /*
          PELÍCULA PDP — pin corto (~1.3 pantallas; antes 3.4, el dueño la sentía muy larga). 2 actos:
          A 0–0.5  el frasco se asienta y el bloque de compra llega a su sitio
          B 0.5–1  el frasco gira apenas y se aleja; el orbe crece. El precio y el botón NUNCA se desvanecen:
                   al soltar el pin la ficha sigue con scroll normal hacia la descripción.
        */
        var PIN = 1.3;
        var pinTl = gsap.timeline({
          scrollTrigger: {
            trigger: scene,
            start: 'top top',
            end: function () { return '+=' + Math.round(innerHeight * PIN); },
            scrub: 0.4,
            pin: true,
            pinSpacing: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
            onUpdate: function (self) {
              var i = $('.cine-pin-progress i', scene);
              if (i) i.style.transform = 'scaleX(' + self.progress + ')';
            }
          }
        });
        pinTl
          .to('.cine-pdp-media', { xPercent: 0, scale: 1, duration: 1, ease: 'none' }, 0)
          .to('.cine-pdp-media .pdp-main', { scale: 1, y: 0, duration: 1, ease: 'none' }, 0)
          .to('.cine-pdp-copy', { xPercent: 0, y: 0, duration: 1, ease: 'none' }, 0)
          .to('.cine-orb--p', { scale: 1.1, opacity: 0.9, duration: 1, ease: 'none' }, 0)
          .to('.cine-pdp-media', { xPercent: -6, scale: 0.9, duration: 1, ease: 'none' }, 1)
          .to('.cine-pdp-media .pdp-main', { y: -18, rotate: -4, duration: 1, ease: 'none' }, 1)
          .to('.cine-pdp-copy', { y: -12, duration: 1, ease: 'none' }, 1)
          .to('.cine-orb--p', { scale: 1.8, x: 110, opacity: 0.8, duration: 1, ease: 'none' }, 1);
        window.__nmPdpPin = pinTl.scrollTrigger;
      } else if (scene && isMobile()) {
        gsap.to('.cine-pdp-media .pdp-main', {
          y: -36, scale: 0.94, ease: 'none',
          scrollTrigger: { trigger: scene, start: 'top top', end: 'bottom top', scrub: 1 }
        });
      }

      $$('.pdp-details, .cine-related').forEach(function (sec) {
        if (!sec || reduce) return;
        var rel = sec.querySelectorAll('.cine-track--rel .card'); /* titulares y descripción: NMText (nm-motion.js) */
        if (rel.length) gsap.from(rel, {
          opacity: 0, y: 32, duration: 0.8, ease: 'expo.out', stagger: 0.05,
          scrollTrigger: { trigger: sec, start: 'top 85%', once: true }
        });
      });

      /* P6 · Relacionados: el destacado entra desde la izquierda y la lista desde la derecha (misma distancia que el patrón
         «cada elemento desde su lado» de tienda-fixes: 56 px; en móvil 20 px). GSAP toma el relevo del respaldo CSS
         (data-reveal) para no animar dos veces. Sin JS o con «Reducir movimiento» el contenido queda visible y quieto. */
      /* P6c · cierre de ficha: el título sube con NMText; los botones entran desde la derecha. */
      var nxt = $('.pdp-next');
      if (nxt && !reduce) {
        var nb = $$('.pdp-next-act > *', nxt), nd = isMobile() ? 16 : 48;
        if (nb.length) gsap.from(nb, {x:nd, autoAlpha:0, duration:.9, ease:'expo.out', stagger:.08, clearProps:'transform,opacity,visibility', scrollTrigger:{trigger:nxt, start:'top 90%', once:true}});
      }

      var rx = $('.rx[data-rx]');
      if (rx && !reduce) {
        var rxF = $('.rx-feat', rx), rxS = $('.rx-side', rx);
        var rxRows = rxS ? $$('.rx-row:not([hidden])', rxS) : [];
        var rxD = isMobile() ? 20 : 56;
        rx.removeAttribute('data-reveal');
        var rxTl = gsap.timeline({ scrollTrigger: { trigger: $('.rx-body', rx) || rx, start: 'top 86%', once: true } });
        if (rxF) rxTl.fromTo(rxF, { x: -rxD, autoAlpha: 0, transition: 'none' }, { x: 0, autoAlpha: 1, duration: 1.05, ease: 'expo.out', clearProps: 'transform,opacity,visibility,transition' }, 0);
        if (rxS) rxTl.fromTo(rxS, { x: rxD, autoAlpha: 0 }, { x: 0, autoAlpha: 1, duration: 1.05, ease: 'expo.out', clearProps: 'transform,opacity,visibility' }, 0.1);
        if (rxRows.length) rxTl.fromTo(rxRows, { x: rxD * 0.45, opacity: 0 }, { x: 0, opacity: 1, duration: 0.8, ease: 'expo.out', stagger: 0.07, clearProps: 'transform,opacity' }, 0.22);
      }
    }

    var sky = $('#sky');
    if (sky && !document.body.classList.contains('tpl-index')) {
      ScrollTrigger.create({
        start: 0, end: 'max',
        onUpdate: function (s) {
          sky.style.setProperty('--gx', (78 - s.progress * 40) + '%');
          sky.style.setProperty('--gy', (18 + s.progress * 35) + '%');
        }
      });
    }

    requestAnimationFrame(function () { ScrollTrigger.refresh(); });
    addEventListener('load', function () { ScrollTrigger.refresh(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
